//
// profileStore
//
import PropTypes from 'prop-types';

import BrowserContext from './BrowserContext';
import contextDefaultValues from './contextDefaultValues';

const BrowserProvider = function BrowserProvider(props) {
  const {
    children,
  } = props;

  // logDev(`browserExtra=${displayJson(contextDefaultValues, 3)}`);

  // const { navigator } = window;

  // // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/getBattery
  // // https://developer.mozilla.org/en-US/docs/Web/API/Battery_Status_API
  // if (navigator.getBattery) {
  //   navigator.getBattery().then((battery) => {
  //     function updateChargeInfo() {
  //       console.log(`Battery charging? ${
  //         battery.charging ? 'Yes' : 'No'}`);
  //     }
  //     battery.addEventListener('chargingchange', () => {
  //       updateChargeInfo();
  //     });

  //     function updateLevelInfo() {
  //       console.log(`Battery level: ${
  //         battery.level * 100}%`);
  //     }
  //     battery.addEventListener('levelchange', () => {
  //       updateLevelInfo();
  //     });

  //     function updateChargingInfo() {
  //       console.log(`Battery charging time: ${
  //         battery.chargingTime} seconds`);
  //     }
  //     battery.addEventListener('chargingtimechange', () => {
  //       updateChargingInfo();
  //     });

  //     function updateDischargingInfo() {
  //       console.log(`Battery discharging time: ${
  //         battery.dischargingTime} seconds`);
  //     }
  //     battery.addEventListener('dischargingtimechange', () => {
  //       updateDischargingInfo();
  //     });

  //     function updateAllBatteryInfo() {
  //       updateChargeInfo();
  //       updateLevelInfo();
  //       updateChargingInfo();
  //       updateDischargingInfo();
  //     }
  //     updateAllBatteryInfo();
  //   });
  // }

  return (
    <BrowserContext.Provider
      value={contextDefaultValues}
    >
      {children}
    </BrowserContext.Provider>
  );
};

BrowserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BrowserProvider;
